import AdminPage from '../views/AdminPage.vue';
import AdminsList from '../components/Admins/AdminsList.vue';
import AdminEditPage from '../components/Admins/AdminEditPage.vue';
import AdminCreatePage from '../components/Admins/AdminCreatePage.vue';

export default [
  {
    path: '/admins',
    name: 'adminParent',
    component: AdminPage,
    meta: {
      title: 'admins',
      requiresAuth: true,
      hideBreadcrumb: true,
      action: 'views.admins.read'
    },
    redirect: { name: 'admins' },
    children: [
      {
        path: '',
        name: 'admins',
        component: AdminsList,
        meta: { title: 'adminList', hideBreadcrumb: true, action: 'views.admins.read' }
      },
      {
        path: 'new',
        name: 'adminCreate',
        component: AdminCreatePage,
        meta: { title: 'adminCreate', action: 'views.admins.add' }
      },
      {
        path: ':id',
        name: 'adminEdit',
        component: AdminEditPage,
        meta: { title: 'adminEdit', adminName: true, action: 'views.admins.read' }
      }
    ]
  }
];
